import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["container"]

    connect() {
        if (this.hasScrollPositionStored()) {
            this.restorePosition()
        }
        this.bindPaginationLinks()
    }

    bindPaginationLinks() {
        const links = this.element.querySelectorAll('[data-scroll-position-link]')
        links.forEach(link => {
            link.addEventListener('click', (event) => {
                event.preventDefault()
                this.savePosition()
                window.location.href = link.href
            })
        })
    }

    savePosition() {
        const containerRect = this.containerTarget.getBoundingClientRect()
        const scrollPosition = window.scrollY + containerRect.top
        localStorage.setItem('scrollPosition', scrollPosition)
    }

    restorePosition() {
        const savedPosition = localStorage.getItem('scrollPosition')
        if (savedPosition) {
            window.scrollTo(0, parseInt(savedPosition))
            localStorage.removeItem('scrollPosition')
        }
    }

    hasScrollPositionStored() {
        return localStorage.getItem('scrollPosition') !== null
    }
}
